import React from 'react'
import ZocksLogo from '../../assets/images/zocks-logo-black.svg'
import { Link } from 'react-router'

const WaitListView: React.FC = () => {
  return (
    <div className='auth-container'>
      <WaitListHeader />
      <div className='auth-popup-container'>
        <div className='auth-popup-inner'>
          <div className='wait-list-header' />
          <h2 className='auth-popup-header'>Your subscription was successful</h2>
          <div className='wait-list-container'>
            <div className='w-full'>We will keep you informed about the progress of our waitlist and any important announcements or developments.</div>
            <div className='w-full'>You won't miss a beat!</div>
          </div>
          <div className='wait-list-footer'>
            <Link to='/'>Back to home</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

const WaitListHeader: React.FC = () => (
  <div className='auth-header'>
    <img className='auth-logo' src={ZocksLogo} alt='Zocks logo' />
    <div className='auth-header-text d-none'>Can't you wait?</div>
    <div className='auth-header-link'>
      <a href='https://www.zocks.io/#schedule-demo' target='_blank' rel='noreferrer'>
        Schedule a demo
      </a>
    </div>
  </div>
)

export default WaitListView
